
import React from 'react';

interface LogoProps {
  className?: string;
  showIcon?: boolean;
  iconOnly?: boolean;
  textClassName?: string;
  iconClassName?: string;
  isDarkMode?: boolean;
}

export const WasteMapLogo: React.FC<LogoProps> = ({ 
  className = "", 
  showIcon = true, 
  iconOnly = false,
  textClassName = "text-2xl font-black tracking-tighter text-slate-900 dark:text-white",
  iconClassName = "w-10 h-10 text-slate-900 dark:text-white",
  isDarkMode
}) => {
  // If isDarkMode is not provided, try to detect it from the document class
  const [effectiveDarkMode, setEffectiveDarkMode] = React.useState(isDarkMode ?? document.documentElement.classList.contains('dark'));

  React.useEffect(() => {
    if (isDarkMode !== undefined) {
      setEffectiveDarkMode(isDarkMode);
    } else {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === 'class') {
            setEffectiveDarkMode(document.documentElement.classList.contains('dark'));
          }
        });
      });
      observer.observe(document.documentElement, { attributes: true });
      return () => observer.disconnect();
    }
  }, [isDarkMode]);

  const logoSrc = iconOnly 
    ? (effectiveDarkMode ? "/logo_dark.png" : "/logo_light.png")
    : (effectiveDarkMode ? "/logo_horizontal_dark.png" : "/logo_horizontal_light.png");

  return (
    <div className={`flex items-center justify-center ${className}`}>
      <img 
        src={logoSrc} 
        alt="WasteMap Logo" 
        className="h-full w-auto object-contain max-w-full"
        referrerPolicy="no-referrer"
        onError={(e) => {
          // Fallback to text if image fails to load
          const target = e.target as HTMLImageElement;
          target.style.display = 'none';
          const parent = target.parentElement;
          if (parent && !parent.querySelector('.fallback-text')) {
            const fallback = document.createElement('span');
            fallback.className = `${textClassName} fallback-text`;
            fallback.innerHTML = 'WASTE<span class="text-blue-600">MAP</span>';
            parent.appendChild(fallback);
          }
        }}
      />
    </div>
  );
};
